import { useQuery } from 'react-query';
import { accountService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useAccountDetails = () => {
  return useQuery(
    `${ServerStateKeysEnum.accountDetails}`,
    () => {
      return accountService.getAccountDetails();
    },
    { staleTime: Infinity }
  );
};
